/** KDS Select design tokens — Figma Dropdown (1078:10705). */

export const selectSizes = ['sm', 'md', 'lg'] as const;

export type SelectSize = (typeof selectSizes)[number];

export const selectDefaultSize: SelectSize = 'sm';

/** Human-readable labels for Storybook matrix and autodocs. */
export const selectSizeLabel: Record<SelectSize, string> = {
  sm: 'Small',
  md: 'Medium',
  lg: 'Large',
};

/** Figma trigger heights (px). */
export const selectTriggerHeightPx = {
  sm: 32,
  md: 40,
  lg: 48,
} as const;

/** Figma menu item min heights (px) — matches trigger row height per size. */
export const selectItemMinHeightPx = {
  sm: 32,
  md: 40,
  lg: 48,
} as const;
